import { useOrderFlowContext } from "@src/app/order-flow-context";
import { useOrderInfoContext } from "@src/app/order-info-context";
import Button from "@src/components/button/Button";
import { FC } from "react";

interface AnyOfTheseItemsCardModel {
  src: string;
  name: string;
}
interface CtaModel {
  text: string;
  url?: string;
}

export interface AnyOfTheseItemsModel {
  yesCta: CtaModel;
  noCta: CtaModel;
  title: string;
  items: AnyOfTheseItemsCardModel[];
}

const AnyOfTheseItems: FC<{ data: AnyOfTheseItemsModel }> = (props) => {
  const { data } = props;
  const orderCtx = useOrderInfoContext();
  const flowCtx = useOrderFlowContext();

  const confirmHavingItems = () => {
    orderCtx.setHaveSuggestedItems!(true);
    //todo: handler to enter next step
    flowCtx.handleContinue();
  };

  const denyHavingItems = () => {
    //todo: handler to enter next step
    flowCtx.handleContinue();
  };
  return (
    <div className="fm-o-aoti">
      <div className="fm-container fm-o-aoti__container">
        <div className="fm-o-aoti__head">
          <h2 className="fm-o-aoti__title center">{data.title}</h2>
        </div>
        <div className={`fm-o-aoti__body fm-o-aoti__body--${data.items.length}`}>
          {data.items.map((item, index) => (
            <div className="fm-o-aoti__item" key={index}>
              <img className="fm-o-aoti__item-img" src={item.src} alt={item.name} />
              <span className="fm-o-aoti__item-text">{item.name}</span>
            </div>
          ))}
        </div>
        <div className="fm-o-aoti__buttons">
          <Button text={data.yesCta.text} mainClass="fm-o-aoti__button" styleModifier={["fm-a-button--blue"]} onClick={confirmHavingItems} />
          <Button text={data.noCta.text} mainClass="fm-o-aoti__button" styleModifier={["fm-a-button--dark"]} onClick={denyHavingItems} />
        </div>
      </div>
    </div>
  );
};

export default AnyOfTheseItems;
